import { render, staticRenderFns } from "./PasswordComponent.vue?vue&type=template&id=97e24c4a&scoped=true&"
import script from "./PasswordComponent.vue?vue&type=script&lang=js&"
export * from "./PasswordComponent.vue?vue&type=script&lang=js&"
import style0 from "./PasswordComponent.vue?vue&type=style&index=0&id=97e24c4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e24c4a",
  null
  
)

export default component.exports